// Copyright 2024 Sorama B.V.

import { DialogService } from "aurelia-dialog";
import { autoinject, PLATFORM } from "aurelia-framework";
import { Point3D } from "datatypes/SoramaLocalApi";
import { IModal } from "libraries/WorkflowFramework/Interfaces/IModal";
import { IWorkflowModuleModalInstance } from "libraries/WorkflowFramework/Interfaces/IWorkflowModule";
import { ConfirmationModel } from "modules/dialogs/Confirmation/ConfirmationDialog";
import { ChannelSelection } from "services/ChannelSelection/ChannelSelection";

@autoinject()
export class PsychoAcousticChannelSelectionModal implements IModal<
    PsychoAcousticChannelSelectionModalState,
    PsychoAcousticChannelSelectionModalReturnState
> {
    private channelSelection: ChannelSelection;
    private microphonePositions: Point3D[];
    private isSelectionGlobal: boolean;

    private modalInstance: IWorkflowModuleModalInstance<
        PsychoAcousticChannelSelectionModalState,
        PsychoAcousticChannelSelectionModalReturnState
    >;

    constructor(private readonly dialogService: DialogService) {}
    public activateModal(
        state: PsychoAcousticChannelSelectionModalState,
        modalInstance: IWorkflowModuleModalInstance<
            PsychoAcousticChannelSelectionModalState,
            PsychoAcousticChannelSelectionModalReturnState
        >
    ): void {
        this.channelSelection = new ChannelSelection(state.selectedSelection);
        this.microphonePositions = state.microphonePositions;

        this.modalInstance = modalInstance;
    }

    public close(): PsychoAcousticChannelSelectionModalReturnState {
        return <PsychoAcousticChannelSelectionModalReturnState>{
            microphonePositions: this.microphonePositions,
            selectedSelection: this.channelSelection.getSelection(),
            isSelectionGlobal: this.isSelectionGlobal,
        };
    }

    private async selected(): Promise<void> {
        await this.dialogService
            .open({
                viewModel: PLATFORM.moduleName("modules/dialogs/Confirmation/ConfirmationDialog"),
                model: <ConfirmationModel>{
                    title: "Would you like to update your microphone selection for all open modules, or just for the current one?",
                    text: "",
                    confirmText: "Update all",
                    cancelText: "Update only the selected module",
                    operation: () => {
                        this.isSelectionGlobal = true;
                        this.modalInstance.close();
                    },
                },
                lock: true,
            })
            .whenClosed(() => this.modalInstance.close());
    }
}

// View-Model for modal needs to be first class in the file
export class PsychoAcousticChannelSelectionModalState {
    public microphonePositions: Point3D[];
    public selectedSelection: boolean[];
}

export class PsychoAcousticChannelSelectionModalReturnState {
    public microphonePositions: Point3D[];
    public selectedSelection: boolean[];
    public isSelectionGlobal: boolean;
}
